import { Injectable } from '@angular/core';
import { McticHttpClient } from '@mctic/ng-core';
import {  Regiao } from '../shared/model';
import { Instituicao } from '../shared/model/instituicao.model';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class InstituicaoService {

  private readonly service = '/sepin-backend/rest/instituicoes';

  constructor(private readonly http: McticHttpClient) {
  }

  obterPorRegiao(regiao: Regiao) {
    return this.http.post<Instituicao[]>(`${this.service}/regiao`, regiao);
  }

  obterPorId(idInstituicao: number):Observable<Instituicao> {
    return this.http.get<Instituicao>(`${this.service}/id/${idInstituicao}`);
  }

  obterInstituicoesPorResponsavel(idPessoaResponsavel: number): Observable<Instituicao[]>{
    return this.http.get<Instituicao[]>(`${this.service}/responsavel/${idPessoaResponsavel}`);
  }

  obterInstituicaoPorIdInstituicaoAnoBase(id: number,
    idAnoBase: number): Observable<Instituicao> {
      return this.http.get<Instituicao>(
        `${this.service}/id/${id}/ano-base/${idAnoBase}`
      );
    }

}
